module.exports = __webpack_public_path__ + "static/covermain-01709ac0a1330bfab974c17476474aec.png";